/**
 * @generated SignedSource<<302e9cae38b42322dadcfed7fb801cb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignProjectTileStatusBadge_designProject$data = {
  readonly status: string | null;
  readonly visibility: boolean | null;
  readonly " $fragmentType": "DesignProjectTileStatusBadge_designProject";
};
export type DesignProjectTileStatusBadge_designProject$key = {
  readonly " $data"?: DesignProjectTileStatusBadge_designProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignProjectTileStatusBadge_designProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignProjectTileStatusBadge_designProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    }
  ],
  "type": "designProject",
  "abstractKey": null
};

(node as any).hash = "c40e9bc064687d0b6195968230d6a9a1";

export default node;
